import React, {useRef, useEffect, useState} from "react";
import CollapsibleContainer from '../components/collapsibleContainer';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { FaMap } from "react-icons/fa";
import { TbBoxModel } from "react-icons/tb";
import Stack from '@mui/material/Stack';

import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"

import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp'


import texture from "../Assets/2_no_clouds_4k.jpg"

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import CanvasTexture from "./CanvasTexture";

function ThreeSceneFlat({ texturePath, width, height }) {
  const mountRef = useRef(null);
  const currentRenderer = useRef(null); // Store the renderer in a ref
  const [cursorCoordinates, setCursorCoordinates] = useState(null)
  const dispatch = useDispatch();
  const [scene, setScene] = useState(null);
  
  

  useEffect(() => {
    // Scene setup
    const scene = new THREE.Scene();
    setScene(scene);
    const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});

    const cursor = new THREE.Mesh(new THREE.SphereGeometry(0.1,5,5),
    new THREE.MeshBasicMaterial({color:0xff0000}) );
    cursor.position.copy( {x: 0, y:0, z:-10});
    scene.add( cursor ); 
    const poiRef = [];
    
      for (let index = 0; index < 10; index++) {
        const k = new THREE.Mesh(new THREE.SphereGeometry(0.1,5,5),
        new THREE.MeshBasicMaterial({color:"red"}) );
        k.position.copy( {x: 0, y:0, z:0});
        scene.add( k ); 
        poiRef.push(k);
      }
    
    renderer.setSize(width, height);
    renderer.setClearColor(0x000000, 0); // Set clear color to black with 0 opacity
    mountRef.current.appendChild(renderer.domElement);
    currentRenderer.current = renderer; // Update the current renderer ref

    // Add Raycasting
    // const raycaster = new THREE.Raycaster();
    // const mouse = new THREE.Vector2();

    // function onMouseClick(event) {
    //   const rect = renderer.domElement.getBoundingClientRect();

    //   // Calculate mouse position in normalized device coordinates (-1 to +1) for both axes,
    //   // taking into account the bounding rectangle of the renderer element
    //   mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    //   mouse.y = - ((event.clientY - rect.top) / rect.height) * 2 + 1;

    //   // Update the picking ray with the camera and mouse position
    //   raycaster.setFromCamera(mouse, camera);

    //   // Calculate objects intersecting the picking ray
    //   const intersects = raycaster.intersectObject(rectangle);

    //   if (intersects.length > 0) {
    //     const intersect = intersects[0];
    //     // console.log('Intersect point:', intersect.point);

    //     cursor.position.copy( intersects[ 0 ].point );

    //     const reducenumber = (n)=>Math.round(n*100)/100

    //     const coordinates = {
    //       x:  reducenumber(intersect.uv.x),
    //       y: reducenumber(intersect.uv.y)
    //     }

    //     setCursorCoordinates(coordinates)

    //     console.log(intersect)

    //     // use UV of the intersection
    //     dispatch({type: DATA_ACTIONS.SET_COORDINATES, coordinates: {x: coordinates.x, y: coordinates.y, s: intersects[0].point}})

    //     }
    //   }
    

    // // // Add event listener for mouse clicks
    // window.addEventListener('click', onMouseClick);
  
    // Add sphere
    const geometry = new THREE.PlaneGeometry(20, 10);
    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load(texturePath);
    const material = new THREE.MeshBasicMaterial({ map: texture });
    const rectangle = new THREE.Mesh(geometry, material);
    rectangle.position.set(0,0,0);
    scene.add(rectangle);

    // Lights
    const ambientLight = new THREE.AmbientLight(0x404040, 0.5);
    scene.add(ambientLight);
    const pointLight = new THREE.PointLight(0xffffff, 1);
    pointLight.position.set(10, 10, 10);
    scene.add(pointLight);

    // Camera setup
    camera.position.z = 10;

    // OrbitControls
    

    setInterval(()=>{
      const ls = localStorage.getItem("poi");
      const res = ls?JSON.parse(ls):null;

      const width = 20; // Plane width
      const height = 10; // Plane height

      for (let i = 0; i < poiRef.length; i++) {
        if (i < res.length) {
          const uv = res[i].coordinates;
          // Convert UV coordinates to 3D space
          const x = (uv.x - 0.5) * width;
          const y = (0.5 - uv.y) * height; // Inverting Y because UV(0,0) is bottom-left, but we want top-left
          poiRef[i].position.set(x, -y, 0); // Assuming Z = 0 for a flat plane
          poiRef[i].material.color.set(res[i].color);
        } else {
          poiRef[i].position.set(0, 0, -10);
        }
      }


      // for (let i = 0; i < poiRef.length; i++) {
        
      //   if (i < res.length){
      //     const coo = res[i].coordinates;
      //     poiRef[i].position.set(coo.x*-8, coo.y*-3, 0);
      //     poiRef[i].material.color.set(res[i].color);
      //   } else {
      //     poiRef[i].position.set(0,0,0);
      //   }
      // }
      

    }, 1000);

    // Animation loop
    const animate = (i) => {
      requestAnimationFrame(animate);
      
      renderer.render(scene, camera);
    };
    animate();

    // Cleanup
    return () => {
      mountRef.current.removeChild(renderer.domElement);
      // window.removeEventListener('click', onMouseClick);
    };
  }, [texturePath]); // Removed width and height from dependency array to avoid reinitialization

  useEffect(() => {
    // This useEffect handles resizing
    if (currentRenderer.current) {
      const renderer = currentRenderer.current;
      renderer.setSize(width, height);
      renderer.setPixelRatio(window.devicePixelRatio);
      const camera = renderer.domElement.camera;
      if (camera) {
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
      }
    }
  }, [width, height]); // This useEffect depends on width and height
  

  return (<div ref={mountRef} />)
}

export function HeightSlider() {

    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    const levels = [
      20, 80, 180, 320, 500, 720, 980, 1280, 1620, 2000,
      2420, 2880, 3380, 3920, 4500, 5120, 5780, 6480, 7220, 8000,
      8820, 9680, 10580, 11520, 12500, 13520, 14580, 15680, 16820, 18000,
      19180, 20360, 21540, 22720, 23910, 25093
    ];
    

  const handleChange = (event, newValue) => {
    
    dispatch({type: DATA_ACTIONS.SET_HEIGHT, height: newValue})
  };



  return (

    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
    <b> Altitude </b>
  <Slider aria-label="Volume" value={data.height} onChange={handleChange} style={{color: "black"}} />
   <b style={{width: "100px"}}>{levels[Math.floor(data.height/100*36)]/1000.0}Km</b>
    
</Stack>

    )
}


const TwoD = ({ onTextureReady }) => {

  return (
    <CollapsibleContainer open title="2D Map" icon={<FaMap />}>
      <CanvasTexture onTextureReady={onTextureReady} />
    </CollapsibleContainer>
    )

  // const [width, setWidth] = useState(0);
  // const elementRef = useRef(null);
  // const poi = useSelector(state=>state.data.poi);
  

  // useEffect(() => {
  //   const observer = new ResizeObserver(entries => {
  //     for (let entry of entries) {
  //       const {width} = entry.contentRect;
  //       setWidth(width - 48); // Adjust the width as necessary
  //     }
  //   });

  //   if (elementRef.current) {
  //     observer.observe(elementRef.current);
  //   }

  //   // Cleanup
  //   return () => observer.disconnect();
  // }, []); // Dependencies array is empty, meaning this effect runs once on mount


  // useEffect(()=>{
  //   if (poi){
  //     // localStorage.setItem("poi",JSON.stringify(poi))
  //   }
    
      
    
    
  // }, [poi])

  // return (
  //   <div ref={elementRef} style={{width: "100%", height: "100%"}}>
  //     <CollapsibleContainer open title="2D Map" icon={<FaMap />}>
  //       {width > 0 && (
  //         <div>
  //           <HeightSlider />
  //           <ThreeSceneFlat texturePath={texture} width={width} height={width} getPoi={()=>{

  //             return poi;
  //           }} />
  //         </div>
  //       )}
  //     </CollapsibleContainer>
  //   </div>
  // );
};

export default TwoD;